import { map } from 'lodash';
import React, { useState, useEffect } from 'react'
import {  Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';
import { useLocation } from 'react-router-dom';

import "./Products.css"

function Products() {
    const location = useLocation();
    const [activeTab, setActiveTab] = useState('1');
    
    // Handle navigation from home page
    useEffect(() => {
        if (location.state && location.state.activeTab) {
            setActiveTab(location.state.activeTab);
        }
    }, [location.state]);

    const productData = {
                coldDrinks: [
                    {
                        cardImageAlt: "WayCup-Lotus",
                        cardImage: "/images/products/items/coldDrinks/WayCup-lotus.jpg",
                        cardTitle: "WayCup Lotus",
                        cardText: "milk, ice, lotus, caramel, WayCup unique flavors",
                        cardSubtitle: "2.75$"
                    },

                    {
                        cardImageAlt: "WayCup-cookies-and-cream",
                        cardImage: "/images/products/items/coldDrinks/WayCup-cookies-and-cream.jpg",
                        cardTitle: "WayCup Cookies and Cream",
                        cardText: "milk, ice, cookies and cream, caramel, WayCup unique flavors",
                        cardSubtitle: "2.75$"
                    },

                    {
                        cardImageAlt: "WayCup-oreo",
                        cardImage: "/images/products/items/coldDrinks/WayCup-oreo.jpg",
                        cardTitle: "WayCup Oreo",
                        cardText: "milk, ice, oreo, caramel, WayCup unique flavors",
                        cardSubtitle: "2.75$"
                    },

                    {
                        cardImageAlt: "WayCup-charcoal-coconut",
                        cardImage: "/images/products/items/coldDrinks/WayCup-charcoal-coconut.jpg",
                        cardTitle: "WayCup Charcoal Coconut",
                        cardText: "milk, ice, coconut, caramel, WayCup unique flavors",
                        cardSubtitle: "2.75$"
                    },

                    {
                        cardImageAlt: "WayCup-iced-coffee",
                        cardImage: "/images/products/items/coldDrinks/WayCup-iced-coffee.jpg",
                        cardTitle: "WayCup Iced Coffee",
                        cardText: "fresh milk, coffee, WayCup unique flavors, sweetener (sugar, honey, syrup)",
                        flavors: "chocolate, caramel, mix",
                        cardSubtitle: "2.25$  |  2.50$  |  2.75$"
                    },

                    {
                        cardImageAlt: "iced-latte",
                        cardImage: "/images/products/items/coldDrinks/iced-latte.jpg",
                        cardTitle: "Iced Latte",
                        cardText: "fresh milk, coffee, sweetener (sugar, honey, syrup)",
                        flavors: "vanilla, caramel, crème brûlée, coconut, Irish cream",
                        cardSubtitle: "2.75$"
                    },

                    {
                        cardImageAlt: "iced-mocha",
                        cardImage: "/images/products/items/coldDrinks/iced-mocha.jpg",
                        cardTitle: "Iced Mocha ",
                        cardText: "chocolate, milk, coffee",
                        cardSubtitle: "2.75$ | 3.90$"
                    },

                    {
                        cardImageAlt: "iced-americano",
                        cardImage: "/images/products/items/coldDrinks/iced-americano.jpg",
                        cardTitle: "Iced Americano",
                        cardText: "coffee, sweetener (sugar, honey, syrup)",
                        cardSubtitle: "1.50$ | 2.00$ | 2.20$"
                    },

                    {
                        cardImageAlt: "iced-macchiato",
                        cardImage: "/images/products/items/coldDrinks/iced-macchiato.jpg",
                        cardTitle: "Iced Macchiato",
                        cardText: "caramel, milk, coffee",
                        cardSubtitle: "2.75$ | 3.90$"
                    },

                    {
                        cardImageAlt: "mocha-frappe",
                        cardImage: "/images/products/items/coldDrinks/mocha-frappe.jpg",
                        cardTitle: "Mocha Frappe ",
                        cardText: "chocolate, milk, coffee",
                        cardSubtitle: "2.75$ | 3.90$"
                    },

                    {
                        cardImageAlt: "creme-brulee-frappe",
                        cardImage: "/images/products/items/coldDrinks/creme-brulee-frappe.jpg",
                        cardTitle: "Crème Brûlée Frappe ",
                        cardText: "crème brûlée, milk, coffee",
                        cardSubtitle: "2.75$ | 3.90$"
                    },

                    {
                        cardImageAlt: "caramel-frappe",
                        cardImage: "/images/products/items/coldDrinks/caramel-frappe.jpg",
                        cardTitle: "Caramel Frappe ",
                        cardText: "caramel, milk, coffee",
                        cardSubtitle: "2.75$ | 3.90$"
                    },

                    {
                        cardImageAlt: "toffee-frappe",
                        cardImage: "/images/products/items/coldDrinks/toffee-frappe.jpg",
                        cardTitle: "Toffee Frappe ",
                        cardText: "toffee, caramel, milk, coffee",
                        cardSubtitle: "2.75$ | 3.90$"
                    },

                    {
                        cardImageAlt: "smoothies",
                        cardImage: "/images/products/items/coldDrinks/smoothies.jpg",
                        cardTitle: "Smoothies",
                        cardText: "water, crushed ice, puréed fruits",
                        flavors: " strawberry, blueberry, mango, pineapple, raspberry, peach, passion fruit, mixed berry, mango peach",
                        cardSubtitle: "2.75$ | 3.30$"
                    },

                    {
                        cardImageAlt: "refreshers",
                        cardImage: "/images/products/items/coldDrinks/refreshers.jpg",
                        cardTitle: "Refreshers",
                        cardText: "syrup, sparkling water, ice cubes ",
                        flavors: "all flavors available",
                        cardSubtitle: "1.70$"
                    },

                    {
                        cardImageAlt: "milkshakes",
                        cardImage: "/images/products/items/coldDrinks/milkshakes.jpg",
                        cardTitle: "Milkshakes",
                        cardText: "milk, crushed ice, puréed fruits",
                        flavors: "Strawberry, chocolate, mixed berry, mango peach, strawberry mango",
                        cardSubtitle: "2.75$"
                    },

                ],
                hotDrinks: [
                    {
                        cardImageAlt: "espresso",
                        cardImage: "/images/products/items/hotDrinks/espresso.jpg",
                        cardTitle: "Espresso ",
                        cardSubtitle: " 0.80$ | 1.20$",
                    },

                    {
                        cardImageAlt: "nescafe",
                        cardImage: "/images/products/items/hotDrinks/nescafe.jpg",
                        cardTitle: "Nescafe ",
                        cardText: " nescafe, coffeemate, condensed milk",
                        cardSubtitle: " 1.00$ | 1.20$ ",
                    },

                    {
                        cardImageAlt: "hot-chocolate",
                        cardImage: "/images/products/items/hotDrinks/hot-chocolate.jpg",
                        cardTitle: "Hot Chocolate ",
                        cardText: "chocolate powder, coffeemate, condensed milk",
                        cardSubtitle: " 1.00$ | 1.20$ ",
                    },

                    {
                        cardImageAlt: "cappuccino",
                        cardImage: "/images/products/items/hotDrinks/cappuccino.jpg",
                        cardTitle: "Cappuccino",
                        cardText: " Cappuccino powder, coffeemate, condensed milk",
                        cardSubtitle: " 1.00$ | 1.20$ ",
                    },

                    {
                        cardImageAlt: "americano",
                        cardImage: "/images/products/items/hotDrinks/americano.jpg",
                        cardTitle: "Americano ",
                        cardText: " Espresso, water",
                        cardSubtitle: " 1.00$",
                    },

                    {
                        cardImageAlt: "latte",
                        cardImage: "/images/products/items/hotDrinks/latte.jpg",
                        cardTitle: "Latte ",
                        cardText: " Espresso, milk",
                        flavors: "all flavors available",
                        cardSubtitle: " 2.75$",
                    },

                    {
                        cardImageAlt: "mocha",
                        cardImage: "/images/products/items/hotDrinks/mocha.jpg",
                        cardTitle: "Mocha ",
                        cardText: " Espresso, chocolate, milk",
                        cardSubtitle: " 2.75$",
                    },

                    {
                        cardImageAlt: "macchiato",
                        cardImage: "/images/products/items/hotDrinks/macchiato.jpg",
                        cardTitle: "Macchiato ",
                        cardText: " Espresso, caramel, milk",
                        cardSubtitle: " 2.75$",
                    },

                    {
                        cardImageAlt: "tea",
                        cardImage: "/images/products/items/hotDrinks/tea.jpg",
                        cardTitle: "Tea",
                        cardSubtitle: " 0.80$",
                    },
                ],
                market: [
                    {
                        cardImageAlt: "protein-bars",
                        cardImage: "/images/products/items/market/protein-bars.jpg",
                        cardTitle: "Protein Bars",
                    },
                    {
                        cardImageAlt: "protein-shakes",
                        cardImage: "/images/products/items/market/protein-shakes.jpg",
                        cardTitle: "Protein Shakes",
                    },
                    {
                        cardImageAlt: "imported-alcohol-drinks",
                        cardImage: "/images/products/items/market/imported-alcohol-drinks.jpg",
                        cardTitle: "Imported Alcohol Drinks",
                    },
                    {
                        cardImageAlt: "imported-energy-drinks",
                        cardImage: "/images/products/items/market/imported-energy-drinks.jpg",
                        cardTitle: "Imported Energy Drinks",
                    },
                    {
                        cardImageAlt: "imported-refreshers",
                        cardImage: "/images/products/items/market/imported-refreshers.jpg",
                        cardTitle: "Imported Refreshers",
                    },
                    {
                        cardImageAlt: "vape",
                        cardImage: "/images/products/items/market/vape.jpg",
                        cardTitle: "Vape",
                    },
                    {
                        cardImageAlt: "imported-candies",
                        cardImage: "/images/products/items/market/imported-candies.jpg",
                        cardTitle: "Imported Candies",
                    },
                    {
                        cardImageAlt: "ready-noodles",
                        cardImage: "/images/products/items/market/ready-noodles.jpg",
                        cardTitle: "Ready Noodles",
                    },
                ],
                sandwiches: [
                    {
                        cardImageAlt: "kaak-mix-cheese",
                        cardImage: "/images/products/items/sandwiches/kaak-mix-cheese.jpg",
                        cardTitle: "Kaak Mix Cheese",
                        cardText: "mozzarella, kashkawan, akkawi, picon",
                        cardSubtitle: "2.75$"
                    },
                    {
                        cardImageAlt: "kaak-four-cheese",
                        cardImage: "/images/products/items/sandwiches/kaak-four-cheese.jpg",
                        cardTitle: "Kaak Four Cheese",
                        cardText: "mozzarella, kashkawan, akkawi, picon, cheddar",
                        cardSubtitle: "3.30$"
                    },
                    {
                        cardImageAlt: "kaak-ham-and-cheese",
                        cardImage: "/images/products/items/sandwiches/kaak-ham-and-cheese.jpg",
                        cardTitle: "Kaak Ham and Cheese",
                        cardText: "ham, mozzarella, kashkawan, akkawi, picon",
                        cardSubtitle: "4.00$ Add (pickles lettuce mayonnaise 1$)"
                    },
                    {
                        cardImageAlt: "kaak-turkey-and-cheese",
                        cardImage: "/images/products/items/sandwiches/kaak-turkey-and-cheese.jpg",
                        cardTitle: "Kaak Turkey and Cheese",                          
                        cardText: "turkey, mozzarella, kashkawan, akkawi, picon",
                        cardSubtitle: "4.00$ Add (pickles lettuce mayonnaise 1$)"
                    },
                    {
                        cardImageAlt: "kaak-submarine",
                        cardImage: "/images/products/items/sandwiches/kaak-submarine.jpg",
                        cardTitle: "Kaak Submarine",
                        cardText: "ham, salami, mixed cheese, pickles, lettuce, tomato, sauces",
                        cardSubtitle: "5.00$"
                    },
                    {
                        cardImageAlt: "baguette-Pastirma-and-labne",
                        cardImage: "/images/products/items/sandwiches/baguette-pastirma-and-labne.jpg",
                        cardTitle: "Baguette Pastirma and Labne",
                        cardText: "pastirma, labne,tomato, lettuce",
                        cardSubtitle: "5.00$"
                    },
                    {
                        cardImageAlt: "baguette-turkey-and-cheese",
                        cardImage: "/images/products/items/sandwiches/baguette-turkey-and-cheese.jpg",
                        cardTitle: "Baguette Turkey and Cheese",
                        cardText: "turkey, mozzarella, kashkawan, akkawi, picon",
                        cardSubtitle: "5.00$"
                    },
                    {
                        cardImageAlt: "baguette-submarine",
                        cardImage: "/images/products/items/sandwiches/baguette-submarine.jpg",
                        cardTitle: "Baguette Submarine",
                        cardText: "ham, salami, mixed cheese, pickles, lettuce, tomato, sauces",
                        cardSubtitle: "5.00$"
                    },
                    {
                        cardImageAlt: "tuna-sandwich",
                        cardImage: "/images/products/items/sandwiches/tuna-sandwich.jpg",
                        cardTitle: "Tuna Sandwich",
                        cardText: "tuna, corne, lettuce, sauces, pickles",
                        cardSubtitle: "2.75$"
                    },
                    {
                        cardImageAlt: "club-sandwich",
                        cardImage: "/images/products/items/sandwiches/club-sandwich.jpg",
                        cardTitle: "Club Sandwich",
                        cardText: "turkey, kashkawan, rocca, sauce",
                        cardSubtitle: "2.75$"
                    },
                    {
                        cardImageAlt: "turkey-and-cheese-sandwich",
                        cardImage: "/images/products/items/sandwiches/turkey-and-cheese-sandwich.jpg",
                        cardTitle: "Turkey and Cheese Sandwich",
                        cardText: "Turkey, kashkawan, lettuce, mayo",
                        cardSubtitle: "2.75$"   
                    },
                ]
            }


    const toggle = (tab) => {
        if (activeTab !== tab) {
            setActiveTab(tab);
        }
    }

    return (
            <div id="productsMainContainer">
                <div className='container bigBodyContainer'>
                    <div className="products-header">
                        <h1 className="products-title">Our Menu</h1>
                        <p className="products-subtitle">Discover our premium selection of coffee, food, and market items</p>
                    </div>
                    <Nav tabs className="mb-4 sticky-top-tabs modern-product-tabs">
                        <NavItem>
                            <NavLink
                                className={`modern-tab-link ${activeTab === '1' ? 'active' : ''}`}
                                onClick={() => toggle('1')}
                            >
                                <span className="tab-icon">🧊</span>
                                Cold Drinks
                            </NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink
                                className={`modern-tab-link ${activeTab === '2' ? 'active' : ''}`}
                                onClick={() => toggle('2')}
                            >
                                <span className="tab-icon">☕</span>
                                Hot Drinks
                            </NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink
                                className={`modern-tab-link ${activeTab === '3' ? 'active' : ''}`}
                                onClick={() => toggle('3')}
                            >
                                <span className="tab-icon">🛒</span>
                                Market
                            </NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink
                                className={`modern-tab-link ${activeTab === '4' ? 'active' : ''}`}
                                onClick={() => toggle('4')}
                            >
                                <span className="tab-icon">🥪</span>
                                Sandwiches
                            </NavLink>
                        </NavItem>
                    </Nav>

                    <TabContent activeTab={activeTab}>
                        <TabPane tabId="1">
                            <div className='row' style={{ padding: "10px" }}>
                                {map(productData.coldDrinks, (eachElem, key) => {
                                    return (
                                        <div className='productCard col-12 modern-product-card' key={key}>
                                            <div className='row product-card-content'>
                                                {(key % 2 === 0 || window.innerWidth < 767) &&
                                                    <div className='col-12 col-md-4 product-image-col'>
                                                        <div className="product-image-container">
                                                            <img alt={eachElem.cardImageAlt} src={eachElem.cardImage} className="product-image" />
                                                            <div className="product-price-badge">{eachElem.cardSubtitle}</div>
                                                        </div>
                                                    </div>
                                                }
                                                <div className='col-12 col-md-8 product-info-col'>
                                                    <div className="product-info">
                                                        <h5 className="product-title">{eachElem.cardTitle}</h5>
                                                        <p className="product-description">{eachElem.cardText}</p>
                                                        {eachElem.flavors && <p className="product-flavors">{eachElem.flavors}</p>}
                                                    </div>
                                                </div>
                                                {key % 2 === 1 && window.innerWidth >= 767 &&
                                                    <div className='col-12 col-md-4 product-image-col'>
                                                        <div className="product-image-container">
                                                            <img alt={eachElem.cardImageAlt} src={eachElem.cardImage} className="product-image" />
                                                            <div className="product-price-badge">{eachElem.cardSubtitle}</div>
                                                        </div>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    )
                                })}
                            </div>
                        </TabPane>
                        <TabPane tabId="2">
                            <div className='row' style={{ padding: "10px" }}>
                                {map(productData.hotDrinks, (eachElem, key) => {
                                    return (
                                        <div className='productCard col-12 modern-product-card' key={key}>
                                            <div className='row product-card-content'>
                                                {(key % 2 === 0 || window.innerWidth < 767) &&
                                                    <div className='col-12 col-md-4 product-image-col'>
                                                        <div className="product-image-container">
                                                            <img alt={eachElem.cardImageAlt} src={eachElem.cardImage} className="product-image" />
                                                            <div className="product-price-badge">{eachElem.cardSubtitle}</div>
                                                        </div>
                                                    </div>
                                                }
                                                <div className='col-12 col-md-8 product-info-col'>
                                                    <div className="product-info">
                                                        <h5 className="product-title">{eachElem.cardTitle}</h5>
                                                        <p className="product-description">{eachElem.cardText}</p>
                                                    </div>
                                                </div>
                                                {key % 2 === 1 && window.innerWidth >= 767 &&
                                                    <div className='col-12 col-md-4 product-image-col'>
                                                        <div className="product-image-container">
                                                            <img alt={eachElem.cardImageAlt} src={eachElem.cardImage} className="product-image" />
                                                            <div className="product-price-badge">{eachElem.cardSubtitle}</div>
                                                        </div>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    )
                                })}
                            </div>
                        </TabPane>
                        <TabPane tabId="3">
                            <div className='row' style={{ padding: "10px" }}>
                                {map(productData.market, (eachElem, key) => {
                                    return (
                                        <div className='productCard col-12 modern-product-card' key={key}>
                                            <div className='row product-card-content'>
                                                {(key % 2 === 0 || window.innerWidth < 767) &&
                                                    <div className='col-12 col-md-4 product-image-col'>
                                                        <div className="product-image-container">
                                                            <img alt={eachElem.cardImageAlt} src={eachElem.cardImage} className="product-image" />
                                                            {eachElem.cardSubtitle && <div className="product-price-badge">{eachElem.cardSubtitle}</div>}
                                                        </div>
                                                    </div>
                                                }
                                                <div className='col-12 col-md-8 product-info-col'>
                                                    <div className="product-info">
                                                        <h5 className="product-title">{eachElem.cardTitle}</h5>
                                                        <p className="product-description">{eachElem.cardText}</p>
                                                    </div>
                                                </div>
                                                {key % 2 === 1 && window.innerWidth >= 767 &&
                                                    <div className='col-12 col-md-4 product-image-col'>
                                                        <div className="product-image-container">
                                                            <img alt={eachElem.cardImageAlt} src={eachElem.cardImage} className="product-image" />
                                                            {eachElem.cardSubtitle && <div className="product-price-badge">{eachElem.cardSubtitle}</div>}
                                                        </div>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    )
                                })}
                            </div>
                        </TabPane>
                        <TabPane tabId="4">
                            <div className='row' style={{ padding: "10px" }}>
                                {map(productData.sandwiches, (eachElem, key) => {
                                    return (
                                        <div className='productCard col-12 modern-product-card' key={key}>
                                            <div className='row product-card-content'>
                                                {(key % 2 === 0 || window.innerWidth < 767) &&
                                                    <div className='col-12 col-md-4 product-image-col'>
                                                        <div className="product-image-container">
                                                            <img alt={eachElem.cardImageAlt} src={eachElem.cardImage} className="product-image" />
                                                            <div className="product-price-badge">{eachElem.cardSubtitle}</div>
                                                        </div>
                                                    </div>
                                                }
                                                <div className='col-12 col-md-8 product-info-col'>
                                                    <div className="product-info">
                                                        <h5 className="product-title">{eachElem.cardTitle}</h5>
                                                        <p className="product-description">{eachElem.cardText}</p>
                                                    </div>
                                                </div>
                                                {key % 2 === 1 && window.innerWidth >= 767 &&
                                                    <div className='col-12 col-md-4 product-image-col'>
                                                        <div className="product-image-container">
                                                            <img alt={eachElem.cardImageAlt} src={eachElem.cardImage} className="product-image" />
                                                            <div className="product-price-badge">{eachElem.cardSubtitle}</div>
                                                        </div>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    )
                                })}
                            </div>
                        </TabPane>
                    </TabContent>
                </div>
            </div>
        );
}

export default Products;